// extracted by mini-css-extract-plugin
export var banner = "_jl-0";
export var closeButton = "_jl-2";
export var greenCheckmark = "_jl-3";
export var hereLink = "_jl-4";
export var titleIcon = "_jl-1";